/**
 * 全局过滤器
 * */

import methods from './methods'

export default {
  ...methods, // 使所有methods中的方法都能当成filters来使用
}